import { Route, Switch} from "react-router-dom"
import { Router } from 'react-router';
import PrivateRoute from "./utils/PrivateRoute"
import { AuthProvider } from './context/AuthContext'

import History from "./utils/History";
// https://stackoverflow.com/questions/42941708/react-history-push-is-updating-url-but-not-navigating-to-it-in-browser

import LoginPage from './views/LoginPage/LoginPage';
import DashboardPage from './views/DashboardPage/DashboardPage';
import RecoverPassPage from './views/RecoverPassPage/RecoverPassPage';

function App() {
  return (
    <Router history={History}>
      <AuthProvider>
        <Switch>
          <Route component={LoginPage} path="/" exact />
          <PrivateRoute component={DashboardPage} path="/dashboard" exact />
          <Route component={RecoverPassPage} path="/auth/forgot_password_confirm/:uid/:token" />
        </Switch>
      </AuthProvider>
    </Router>
  )
}

export default App;
